export const setTreatingOrgOptions = ({ columns, data }) => {
  const tAccessor = columns.findIndex((c) => c.accessor === 'treatingOrg');

  data.forEach((t) => {
    const tIndex = columns[tAccessor].options.findIndex((x) => x.id === t.id);

    if (tIndex === -1)
      columns[tAccessor].options.push({
        id: t.id,
        value: t.id,
        label: t.name,
        selected: true,
      });
  });

  return columns;
};
